import Done from '@mui/icons-material/Done';
import Remove from '@mui/icons-material/Remove';
import React from 'react';
import { POLIMER, SUBSTANCE } from 'utils/constants/coreConstants';

export default user => {
  const columns = [
    {
      title: 'Nome',
      field: 'name',
      minWidth: 600,
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'left',
      },
    },
    {
      title: 'Tipo',
      field: 'type',
      minWidth: 100,
      initialEditValue: SUBSTANCE,
      lookup: {
        [SUBSTANCE]: 'Substância',
        [POLIMER]: 'Polímero',
      },
    },
    {
      title: 'CAS',
      field: 'cas',
      minWidth: 100,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      render: rowData => rowData.cas && rowData.cas.length !== 0 ?
        rowData.cas.join(', ') :
        null,
    },
    {
      title: 'EC',
      field: 'ec',
      minWidth: 100,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      render: rowData => rowData.ec && rowData.ec.length !== 0 ?
        rowData.ec.join(', ') :
        null,
    },
    {
      title: 'Perigosa',
      field: 'hazardous',
      type: 'boolean',
      minWidth: 90,
      initialEditValue: 'true',
      headerStyle: {
        textAlign: 'center'
      },
      cellStyle: {
        textAlign: 'center'
      },
      lookup: {
        true: 'Sim',
        false: 'Não'
      },
      render: rowData =>
        <span style={{ fontWeight: rowData.hazardous ? 'bold' : null }}>
        {rowData.hazardous ? 'Sim' : 'Não' }
      </span>
    }
  ];

  const columnsAdmin = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      width: 100,
    },
    ...columns
  ];

  return user.superuser ? columnsAdmin : columns;
};
